import React from "react";
import { Box, Tooltip, TableCell } from "@mui/material";
import { FaTruckFast } from "react-icons/fa6";
import { FaBoxArchive } from "react-icons/fa6";
import { BsFillSignStopFill } from "react-icons/bs";

// Columna "Entrega Producto": solo evalúa si puede entregar cuando la
// solicitud está FACTURADO; en cualquier otro estado muestra "Pendiente".
// Si la solicitud tiene (o tuvo) un ciclo de RespaldosPendientesWeb que no
// terminó Aprobado (3) — pendiente de carga, enviado a revisar, volver a
// corregir o rechazado — la entrega se mantiene bloqueada en STOP sin
// importar la verificación de domicilio/laboral.
export default function CeldaEntregaProducto({ data }) {
  const ESTADO_RESPALDOS_APROBADO = 3;
  const bloqueadoPorRespaldos =
    data.RespaldosPendientesEstado != null &&
    data.RespaldosPendientesEstado !== ESTADO_RESPALDOS_APROBADO;

  return (
    <TableCell align="center">
      <Box component="span" sx={{ display: "inline-flex", gap: 1, ml: 1, alignItems: "center" }}>
        {data.estado === "FACTURADO"
          ? (
            <>
              {bloqueadoPorRespaldos ? (
                <Tooltip title="No se puede entregar el producto: hay respaldos pendientes de aprobación." arrow placement="top">
                  <span>
                    <BsFillSignStopFill size={40} color="red" />
                  </span>
                </Tooltip>
              ) : (// Caso 1: Ambos terrenos en 0
                (
                  (data.Domicilio === false && data.Laboral === false) ||

                  // Caso 2: Solo Domicilio activo y aprobado
                  (data.Domicilio === true && data.Laboral === false && data.idEstadoVerificacionDomicilio === 2) ||

                  // Caso 3: Solo Laboral activo y aprobado
                  (data.Domicilio === false && data.Laboral === true && data.idEstadoVerificacionTerrena === 2) ||

                  // Caso 4: Ambos activos y ambos aprobados
                  (data.Domicilio === true && data.idEstadoVerificacionDomicilio === 2 &&
                    data.Laboral === true && data.idEstadoVerificacionTerrena === 2)
                ) ? (
                  <Tooltip title="Puede entregar el producto." arrow placement="top">
                    <span>
                      <FaTruckFast size={30} color="green" />
                    </span>
                  </Tooltip>
                ) : (
                  <Tooltip title="No se puede entregar el producto sin verificación." arrow placement="top">
                    <span>
                      <BsFillSignStopFill size={40} color="red" />
                    </span>
                  </Tooltip>
                )
              )}
            </>
          ) : (
            <>
              <Tooltip title="Pendiente" arrow placement="top">
                <span>
                  <FaBoxArchive size={20} color="gray" />
                </span>
              </Tooltip>
            </>
          )}

      </Box>
    </TableCell>
  );
}
